/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import { React, useState, useEffect, useContext } from 'react'
import AnimatedList from '../../../../components/Animation/AnimatedList'
import { useSearchParams } from 'react-router-dom'
import formatMobileNumber from '../../../../CommonMethods/FormatMobileNumber';
import AnimatedModel from '../../../../components/Animation/AnimatedModel'
import ConfirmationPrompt from '../../../../components/ConfirmationPrompt'
import { useProviderPreferenceChangeMutation, useGetProvidersQuery, useGetMonitorAssociatedToPatientListQuery } from '../../../../slices/patientSlice'
import GlobalContext from "../../../../components/Context/GloablContext"


const TableBodyProvider = ({ tableData, patientId,
    List,
    indexNum }) => {
    const [searchParams, setSearchParams] = useSearchParams({})
    const [changeProviderAccess, setChangeProviderAccess] = useState([])
    const [sendAlert, setSendAlert] = useState([])
    const [confirmationStateStatus, setConfirmationStateStatus] = useState(false)
    const [loading, setLoading] = useState(false)
    const [changePreference] = useProviderPreferenceChangeMutation()
    const { isSideBar, setToastmessage, setToastErrorMessage } = useContext(GlobalContext)
    const { refetch } = useGetProvidersQuery(`patient_id=${patientId}&${searchParams?.toString()}`);
    const { data: monitorsList, isFetching: monitorsFetching, isLoading, status: monitorslistStatus } = useGetMonitorAssociatedToPatientListQuery(patientId, { refetchOnMountOrArgChange: true })

    const handleOnClickEmail = () => {
        const updatedAccess = [...changeProviderAccess];
        updatedAccess[indexNum] = 'email';
        setChangeProviderAccess(updatedAccess);
        if (changeProviderAccess[indexNum] === "email") {
            setConfirmationStateStatus(false);
        } else {
            setConfirmationStateStatus(true);
        }

    };
    const user_id = sessionStorage.getItem('user_id');
    const matchingObject = monitorsList && monitorsList.data.find(obj => obj.monitorUserData.user_id === user_id);

    const handleOnClickCall = () => {
        const updatedAccess = [...changeProviderAccess];
        updatedAccess[indexNum] = 'call';
        setChangeProviderAccess(updatedAccess);
        if (changeProviderAccess[indexNum] === "call") {
            setConfirmationStateStatus(false);
        } else {
            setConfirmationStateStatus(true);
        }
    };
    let preferenceMode = changeProviderAccess[indexNum] || ''; // Use the preference mode for the specific index
    const handleOnCLickActivate = async (e) => {
        if (!sendAlert[indexNum]) return;
        let body = {
            "patient_id": patientId,
            "user_name": tableData?.providerUserData?.user_name,
            "preference_mode": preferenceMode,
            "user_id": tableData?.providerUserData?.user_id,
            "send_alert": true
        };

        setLoading(true)
        const changeProviderPreference = await changePreference({ body })
        setLoading(false)
        if (changeProviderPreference.error) {
            setToastErrorMessage('Something went wrong. Please try again')
        } else {
            setToastmessage(`Preference changed to ${preferenceMode} successfully`);
            if (refetch) { // Check if refetch is defined
                refetch(); // Call refetch if it's defined
            } else {

            }
        }
        setConfirmationStateStatus(false);
    }
    const handleConformationClick = () => {
        setConfirmationStateStatus(false);

        // Check if the current preference access is "email"
        if (changeProviderAccess[indexNum] === "email") {
            // Update the preference access to "call"
            const updatedAccess = [...changeProviderAccess]; // Create a copy of the array
            updatedAccess[indexNum] = "call"; // Change the value at the specified index
            setChangeProviderAccess(updatedAccess); // Update the state with the new array
        } else if (changeProviderAccess[indexNum] === "call") {
            // Update the preference access to "email"
            const updatedAccess = [...changeProviderAccess]; // Create a copy of the array
            updatedAccess[indexNum] = "email"; // Change the value at the specified index
            setChangeProviderAccess(updatedAccess); // Update the state with the new array
        }
        // Assuming this also controls the visibility of the confirmation dialog
    };
    const handleSendAlertToggle = async (tableData) => {
        let updatedSendAlert = [...sendAlert]; // Create a copy of the sendAlert array
        updatedSendAlert[indexNum] = !updatedSendAlert[indexNum]; // Toggle the value at the specified index
        setSendAlert(updatedSendAlert); // Update the state with the new array
    
        let body = {
            "patient_id": patientId,
            "user_name": tableData?.providerUserData?.user_name,
            "preference_mode": tableData?.providerUserData?.preference_mode,
            "user_id": tableData?.providerUserData?.user_id,
            "send_alert": updatedSendAlert[indexNum] // Update the send_alert value in the body
        };
        const response = await changePreference({ body });
        if (response.error) {
            setToastErrorMessage('Something went wrong. Please try again');
        } else {
            if (refetch) { // Check if refetch is defined
                refetch(); // Call refetch if it's defined
            } else {
                console.error('Refetch function is not defined.'); // Log an error if refetch is not defined
            }
        }
    };


    useEffect(() => {
        setChangeProviderAccess(List?.data?.map((item) => item?.providerUserData?.preference_mode))
        setSendAlert(List?.data?.map((item) => item?.providerUserData?.send_alert))
    }, [List])

    return (
        <>
            <AnimatedList
                id={tableData.patient_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                removeHover={true}

                child={
                    <>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.providerUserData?.user_id}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.providerUserData?.first_name}</td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.providerUserData?.last_name}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624]`}>
                            <div className={`border border-[#C5C9DA] ${!sendAlert[indexNum] ? 'bg-[#E7EAF4]' : ''} rounded-[16px] p-1 w-max`}>
                                <button id={`${indexNum}email`} disabled={!sendAlert[indexNum] || tableData?.providerUserData?.email_address === "" || (matchingObject?.monitor_permission === 'view')} onClick={handleOnClickEmail} className={`px-3 py-1.5 text-sm font-semibold text-[#777C88] rounded-[12px] mr-1 ${changeProviderAccess[indexNum] === "email" && (!sendAlert[indexNum] ? 'bg-[#777C88] text-[#C5C9DA] !important' : 'bg-[#008586] text-[#FFFFFF] !important')}`}>
                                    Email
                                </button>
                                <button id={`${indexNum}call`} disabled={!sendAlert[indexNum] || tableData?.providerUserData?.mobile_number === "" || (matchingObject?.monitor_permission === 'view')} onClick={handleOnClickCall} className={`px-3 py-1.5 text-sm font-semibold text-[#777C88] rounded-[12px] ${changeProviderAccess[indexNum] === "call" && (!sendAlert[indexNum] ? 'bg-[#777C88] text-[#C5C9DA] !important' : 'bg-[#008586] text-[#FFFFFF] !important')}`}>
                                    Call
                                </button>

                            </div>
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.providerUserData?.mobile_number ? (
                                <>
                                    {tableData?.providerUserData?.mob_no_country_code}{" "}
                                    {formatMobileNumber(tableData?.providerUserData?.mobile_number)}
                                </>
                            ) : (
                                "-"
                            )}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                            {tableData?.providerUserData?.main_no_country_code} {formatMobileNumber(tableData?.providerUserData?.main_number)}
                        </td>
                        <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{tableData?.providerUserData?.email_address === "" || tableData?.providerUserData?.email_address === undefined ? "-" : tableData?.providerUserData?.email_address}</td>
                        <td className={`px-[18px] py-2 text-sm text-start font-normal text-[#031624] rounded-tr-[2px]  bg-white rounded-br-[2px] sticky right-[-1px] prevent-click last-td`}>
                            <td className="px-[20px] py-2 text-sm text-start font-normal text-[#031624]">  <div className="status custom-toggle flex items-center ">
                                <label className="switch monitor" style={{ marginLeft: '10px' }}>
                                    <input
                                        type="checkbox"
                                        // onChange={(e) => {
                                        //     setSendAlert((prev) => ([...prev.slice(0, indexNum), !sendAlert[indexNum], ...prev.slice(indexNum + 1)]))
                                        // }}
                                        disabled={(matchingObject?.monitor_permission === 'view')}
                                        onChange={() => handleSendAlertToggle(tableData)}
                                        checked={sendAlert[indexNum]}
                                    /><span id={`${indexNum}send`} className="slider round"></span>
                                </label></div></td>
                        </td>
                    </>

                } />

            {confirmationStateStatus &&
                <AnimatedModel
                    Children={
                        <ConfirmationPrompt
                            emptyField={''}
                            setEmptyField={() => { }}
                            handleOnCLickActivate={handleOnCLickActivate}
                            handleClose={handleConformationClick}
                            tittle={'Change Preference Mode'}
                            message={`Are you sure you want to change the preference mode to ${preferenceMode}?`}
                            textMessage={false}
                            buttonName={'Yes'}
                            userList={''}
                            CancelButton={true}
                            disabled={loading}
                            loadingActivation={loading}
                        />
                    }
                />
            }

        </>
    )
}

export default TableBodyProvider